import React from "react";
import classes from "./LoginPage.module.css";
import { connect } from "react-redux";
import { startLogin } from "../actions/auth";
import BrandLogo from "./BrandLogo";
import { useAppBrandInfo } from "../hooks/useAppBrandInfo";

const LoginPage = (props) => {
  const { brandInfo } = useAppBrandInfo();
  return (
    <div className={classes.Screen}>
      <div className={classes.Form}>
        <BrandLogo className={classes.logo} />
        <h1>{brandInfo.product_name}</h1>

        <div>
          <p>{brandInfo.product_description}</p>
        </div>
        <div className={classes.ButtonArea}>
          <button onClick={props.startLogin}>Login with Google</button>
          {/* <button>Guest Mode</button> */}
        </div>
      </div>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  startLogin: () => dispatch(startLogin()),
});
export default connect(undefined, mapDispatchToProps)(LoginPage);
